import { render, staticRenderFns } from "./GenericResponseBox.vue?vue&type=template&id=70937116&"
import script from "./GenericResponseBox.vue?vue&type=script&lang=js&"
export * from "./GenericResponseBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports